
import { StatCard } from "components/card-dashboard/card-style";
import { ProgressBarChart } from "features/dashboard/components/purchase/ProgressBarChart";
import StackedDrilldownChart from "features/dashboard/components/purchase/StackColumnWithDrillDown";
import { SupplierChart } from "features/dashboard/components/purchase/SupplierChart";
import { SalesView } from "features/dashboard/components/sales/sales";
import { useGetDashboardList } from "features/dashboard/use-cases/get-dashboard";
// ../components/sales/sales

const DashboardView = () => {
   const salesFlag = { Flag: "SalesNew" };
  const purchaseFlag = { Flag: "SalesProgress" };
  const purchaseDataDrill = { Flag: "Purchase" };
  const purchaseDataSupplier = { Flag: "PurchaseProgress" };
    const { data: salesData } = useGetDashboardList(salesFlag);
  const { data: purchaseData,isFetching:loading } = useGetDashboardList(purchaseFlag);
  const { data: purchaseDataDrillData,isFetching:isloading } = useGetDashboardList(purchaseDataDrill);
  const { data: purchaseDataSupplierdata,isFetching:isloadingdata } = useGetDashboardList(purchaseDataSupplier);
  
return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-800">
          Overview Dashboard
        </h3>
      </div>

      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard title="Total Sales" value={salesData?.res?.totalMaterialSold} unit="ton" growth={salesData?.res?.totalTrandMaterialSold} direction={salesData?.res?.trandMaterialSoldDirection} />
        <StatCard title="Total Purchase" value={salesData?.res?.totalScrape} unit="ton" growth={salesData?.res?.totalTrandScrape} direction={salesData?.res?.trandScrapeDirection} />
        {/* <StatCard title="Total Scrape" value={salesData?.res?.totalScrape}  />
        <StatCard
          title="Total Material Sold"
          value={salesData?.res?.totalTrandMaterialSold}
        /> */}
      </div>

      {/* Graph Section */}
      <div className="bg-white rounded-2xl p-6">
        <div className="flex justify-between items-center mb-4">
          {/* <h4 className="text-lg font-medium text-gray-800">
            Atulit Admin Graph
          </h4> */}
        </div>
        <div className="grid grid-cols-12 gap-6 p-6">
          <div className="col-span-12 md:col-span-6 bg-white shadow-lg rounded-2xl p-4">
              <SalesView data={salesData}  />
          </div> 

          {/* Right Column */}
          <div className="col-span-12 md:col-span-6 bg-white shadow-lg rounded-2xl p-4">
              <ProgressBarChart data={purchaseData} isFetching={loading}/>
          </div>

           <div className="col-span-12 md:col-span-6 bg-white shadow-lg rounded-2xl p-4">             
              <StackedDrilldownChart data={purchaseDataDrillData?.res} isFetching={isloading}/>
          </div>

          <div className="col-span-12 md:col-span-6 bg-white shadow-lg rounded-2xl p-4">             
              <SupplierChart data={purchaseDataSupplierdata?.res as any} isFetching={isloadingdata} />
             
          </div>

        </div>

      </div>
    </div>
  )
}

export default DashboardView;
